module.exports = __webpack_public_path__ + "static/egyptian-pillowcase-grey-1-25a53aff01cd1aa5bcf70e0d5d80a222.webp";